import { AppTopBar } from 'components/AppTopBar';
import { getTransWithParams } from 'modules/i18n';
import { getWeekLabelWithTimezone } from 'modules/work-weeks';
import { DEFAULT_TIMEZONE } from 'utils/date';
import { useWeekDetails, useWeekPeriod } from '../hooks';

export const WeekDetailsHeader = () => {
  const { weekPeriod, isLoading } = useWeekPeriod();
  const { isError, isLoading: isWeekDetailsLoading } = useWeekDetails();

  if (isLoading || ((!weekPeriod || isError) && !isWeekDetailsLoading)) {
    return <AppTopBar variant="back" />;
  }

  const start = weekPeriod?.calendarWeekStart;
  const end = weekPeriod?.calendarWeekEnd;
  const dateLabelWithTimezone =
    start && end ? getWeekLabelWithTimezone(start, end, DEFAULT_TIMEZONE) : '';

  return (
    <AppTopBar
      variant="back"
      title={getTransWithParams('abbreviations.calendarWeekWithNumber', {
        weekNumber: weekPeriod?.calendarWeek
      })}
      subtitle={dateLabelWithTimezone}
    />
  );
};
